export enum Sesso {
    Empty = '',
    Male = 'M',
    Female = 'F'
}
